import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=2b087046&scoped=true&"
import script from "./translate.vue?vue&type=script&lang=js&"
export * from "./translate.vue?vue&type=script&lang=js&"
import style0 from "./translate.vue?vue&type=style&index=0&id=2b087046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b087046",
  null
  
)

export default component.exports